import { Invoice } from '@otw/models';
import { Vehicle } from '@otw/models/inventory/inventory';

export interface TempTagRetailOrder {
  pdfUrl: string;
  invoiceNumber: string;
  vehicleId: string;
}

const isDownPaymentPdf = (pdfUrl: string): boolean =>
  pdfUrl.includes('down-payment-');

/**
 * Find the newest simple invoice PDF for a single vehicle on a lead.
 * Down-payment PDFs are excluded; PandaDoc retail orders are not used.
 */
export const resolveTempTagRetailOrder = (
  vehicle: Vehicle | null | undefined,
  leadInvoices: Invoice[],
): TempTagRetailOrder | null => {
  if (!vehicle?.id) return null;

  const matching = leadInvoices
    .filter((invoice) => {
      const pdfUrl = invoice.pdf_url?.trim();
      return (
        !!pdfUrl &&
        !isDownPaymentPdf(pdfUrl) &&
        invoice.vehicle_ids?.includes(vehicle.id)
      );
    })
    .sort(
      (a, b) =>
        new Date(b.time_created).getTime() - new Date(a.time_created).getTime(),
    );

  const latest = matching[0];
  const pdfUrl = latest?.pdf_url?.trim();
  if (!pdfUrl) return null;

  return {
    pdfUrl,
    invoiceNumber: latest.invoice_number?.trim() || latest.id,
    vehicleId: vehicle.id,
  };
};
